import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dueStatus',
  pure: true
})
export class DueStatusPipe implements PipeTransform {

  transform(value: Date | number | string, allDay = false): ('future-due'|'today-due'|'near-due'|'over-due') {
    try {
      if (!value) { return 'future-due'; } 
      else if (!isNaN(+value)) { value = new Date(+value); } 
      else if (typeof value == 'string') { value = new Date(!value.includes('Z') && !value.includes('+') ? value + 'Z' : value); }

      const now = new Date();
      const due = new Date(value);
      const diff = due.getTime() - now.getTime();
      if(diff<0) {
        //if allday and diff is less than one day
        if(allDay && diff>-86400000) return 'today-due';
        return 'over-due';
      }
      //if diff is less than 1 hour return near-due
      if(diff<3600000) return 'near-due';
      //if due date is in today (calendar day) return today-due
      if(due.getDate()===now.getDate() && due.getMonth()===now.getMonth() && due.getFullYear()===now.getFullYear()) return 'today-due';
      return 'future-due';
    } catch (err) {
      console.error(err);
      return 'future-due';
    }
  }

}
